package app.bloomey.web.components.modals

import androidx.compose.runtime.*
import app.bloomey.web.core.modal.LocalSiteModelController
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

@Composable
fun ModalHost() {
    val controller = LocalSiteModelController.current
    val sitePalette = ColorMode.current.toSitePalette()
    val modals = controller.modals
    if (modals.isNotEmpty())
        Box(
            modifier = Modifier.fillMaxSize()
                .maxHeight(100.vh)
                .background(
                    ColorMode.current.toSitePalette().background
                        .toRgb().copy(alpha = 50)
                )
                .zIndex(4)
                .onClick {
                    if (modals.lastOrNull()?.popOnClickOutside == true)
                        controller.pop()
                }
        )

    modals.forEach { modal ->
        var bottomOffset by remember { mutableStateOf(100) }
        LaunchedEffect(modal) {
            bottomOffset = 0
        }
        Box(
            modifier = Modifier
                .fillMaxSize()
                .position(Position.Fixed)
                .zIndex(4)
                .padding(leftRight = 2.cssRem)
                .pointerEvents(PointerEvents.None), contentAlignment = Alignment.BottomCenter
        ) {
            modal.Content(
                Modifier.margin(bottom = 50.px)
                    .pointerEvents(PointerEvents.Auto)
                    .maxWidth(500.px)
                    .translateY(bottomOffset.percent)
                    .transition(CSSTransition(TransitionProperty.All, 300.ms))
                    .boxShadow(
                        offsetY = (-2).px,
                        color = sitePalette.onBackground.toRgb().copy(alpha = 20),
                        blurRadius = 12.px,
                        spreadRadius = 1.px
                    )
            )
        }
    }
}